const wowApp = require('angular').module('wowApp.common');

wowApp.directive('olyButton', ['$compile', 'MoveFocus', require('./button.directive')]);



// WEBPACK FOOTER //
// ./src/common/button/index.js